import {CalculatorValueType} from "../types/CalculatorValueType";
import {CreditApplicationSource} from "../types/CreditApplicationSource";
import {RangeOptionNameType} from "../types/RangeOptionNameType";
import {AllCreditGtmActionTypes, CreditGtmActionsType, CreditRatingGtmActionsType, WorthinessSelectsType} from "./types/CreditGtmActionTypes";
import {
    CreditCalculatorGTMEvent,
    CreditCalculatorInstalmentEventAction,
    CreditCalculatorWorthinessEventAction,
    CreditRatingCalculatorEventAction
} from "./credit_gtm";

export const getCreditEventAction = (source: CreditApplicationSource, type: AllCreditGtmActionTypes) => {
    const eventFromSource =
        source === CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT_RATING
            ? CreditCalculatorGTMEvent.CREDIT_RATING_CALCULATOR
            : CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT
              ? CreditCalculatorGTMEvent.CREDIT_INSTALMENT_CALCULATOR
              : CreditCalculatorGTMEvent.CREDIT_WORTHINESS_CALCULATOR;

    if (eventFromSource === CreditCalculatorGTMEvent.CREDIT_INSTALMENT_CALCULATOR) {
        switch (type) {
            case RangeOptionNameType.PRICE:
                return CreditCalculatorInstalmentEventAction.PRICE;
            case RangeOptionNameType.PERIOD:
                return CreditCalculatorInstalmentEventAction.PERIOD;
            case RangeOptionNameType.CONTRIBUTION:
                return CreditCalculatorInstalmentEventAction.CONTRIBUTION;
            case CreditGtmActionsType.CALL:
                return CreditCalculatorInstalmentEventAction.CALL;
            default:
                console.error(`instalment calculator - wrong action typ for event ${eventFromSource}`);
                return null;
        }
    }

    if (eventFromSource === CreditCalculatorGTMEvent.CREDIT_WORTHINESS_CALCULATOR) {
        switch (type) {
            case RangeOptionNameType.PRICE:
                return CreditCalculatorWorthinessEventAction.AMOUNT;
            case RangeOptionNameType.PERIOD:
                return CreditCalculatorWorthinessEventAction.PERIOD;
            case RangeOptionNameType.AGE:
                return CreditCalculatorWorthinessEventAction.AGE;
            case RangeOptionNameType.EARNINGS:
                return CreditCalculatorWorthinessEventAction.EARNINGS;
            case WorthinessSelectsType.APPLICANTS:
                return CreditCalculatorWorthinessEventAction.APPLICANTS;
            case WorthinessSelectsType.PROPERTY_TYPE:
                return CreditCalculatorWorthinessEventAction.PROPERTY_TYPE;
            case CreditGtmActionsType.CALL:
                return CreditCalculatorWorthinessEventAction.CALL;
            default:
                console.error(`worthiness calculator - wrong action typ for event ${eventFromSource}`);
                return null;
        }
    }

    if (eventFromSource === CreditCalculatorGTMEvent.CREDIT_RATING_CALCULATOR) {
        switch (type) {
            case RangeOptionNameType.AGE:
                return CreditRatingCalculatorEventAction.AGE;
            case CreditRatingGtmActionsType.APPLICANTS:
                return CreditRatingCalculatorEventAction.APPLICANTS;
            case CreditRatingGtmActionsType.PROPERTY_TYPE:
                return CreditRatingCalculatorEventAction.PROPERTY_TYPE;
            case CreditRatingGtmActionsType.CALL:
                return CreditRatingCalculatorEventAction.CALL;
            case RangeOptionNameType.AVERAGE_EARNINGS:
                return CreditRatingCalculatorEventAction.LOAN_INSTALLMENTS;
            case RangeOptionNameType.LOAN_INSTALLMENTS:
                return CreditRatingCalculatorEventAction.AVERAGE_EARNINGS;
            case RangeOptionNameType.HOUSEHOLD_EXPENSES:
                return CreditRatingCalculatorEventAction.HOUSEHOLD_EXPENSES;
        }
    }

    console.error(`wrong event for one of credit calculators`);
    return null;
};

export const getCreditEventActionFromCalculatorValueType = (type: CalculatorValueType) => {
    switch (type) {
        case CalculatorValueType.PRICE:
            return CreditCalculatorInstalmentEventAction.PRICE;
        case CalculatorValueType.PERIOD:
            return CreditCalculatorInstalmentEventAction.PERIOD;
        case CalculatorValueType.CONTRIBUTION:
            return CreditCalculatorInstalmentEventAction.CONTRIBUTION;
        default:
            console.error(`getCreditEventActionFromCalculatorValueType wrong type`);
            return "";
    }
};
import {CalculatorValueType} from "../types/CalculatorValueType";
import {CreditApplicationSource} from "../types/CreditApplicationSource";
import {RangeOptionNameType} from "../types/RangeOptionNameType";
import {AllCreditGtmActionTypes, CreditGtmActionsType, CreditRatingGtmActionsType, WorthinessSelectsType} from "./types/CreditGtmActionTypes";
import {
    CreditCalculatorGTMEvent,
    CreditCalculatorInstalmentEventAction,
    CreditCalculatorWorthinessEventAction,
    CreditRatingCalculatorEventAction
} from "./credit_gtm";

export const getCreditEventAction = (source: CreditApplicationSource, type: AllCreditGtmActionTypes) => {
    const eventFromSource =
        source === CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT_RATING
            ? CreditCalculatorGTMEvent.CREDIT_RATING_CALCULATOR
            : CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT
              ? CreditCalculatorGTMEvent.CREDIT_INSTALMENT_CALCULATOR
              : CreditCalculatorGTMEvent.CREDIT_WORTHINESS_CALCULATOR;

    if (eventFromSource === CreditCalculatorGTMEvent.CREDIT_INSTALMENT_CALCULATOR) {
        switch (type) {
            case RangeOptionNameType.PRICE:
                return CreditCalculatorInstalmentEventAction.PRICE;
            case RangeOptionNameType.PERIOD:
                return CreditCalculatorInstalmentEventAction.PERIOD;
            case RangeOptionNameType.CONTRIBUTION:
                return CreditCalculatorInstalmentEventAction.CONTRIBUTION;
            case CreditGtmActionsType.CALL:
                return CreditCalculatorInstalmentEventAction.CALL;
            default:
                console.error(`instalment calculator - wrong action typ for event ${eventFromSource}`);
                return null;
        }
    }

    if (eventFromSource === CreditCalculatorGTMEvent.CREDIT_WORTHINESS_CALCULATOR) {
        switch (type) {
            case RangeOptionNameType.PRICE:
                return CreditCalculatorWorthinessEventAction.AMOUNT;
            case RangeOptionNameType.PERIOD:
                return CreditCalculatorWorthinessEventAction.PERIOD;
            case RangeOptionNameType.AGE:
                return CreditCalculatorWorthinessEventAction.AGE;
            case RangeOptionNameType.EARNINGS:
                return CreditCalculatorWorthinessEventAction.EARNINGS;
            case WorthinessSelectsType.APPLICANTS:
                return CreditCalculatorWorthinessEventAction.APPLICANTS;
            case WorthinessSelectsType.PROPERTY_TYPE:
                return CreditCalculatorWorthinessEventAction.PROPERTY_TYPE;
            case CreditGtmActionsType.CALL:
                return CreditCalculatorWorthinessEventAction.CALL;
            default:
                console.error(`worthiness calculator - wrong action typ for event ${eventFromSource}`);
                return null;
        }
    }

    if (eventFromSource === CreditCalculatorGTMEvent.CREDIT_RATING_CALCULATOR) {
        switch (type) {
            case RangeOptionNameType.AGE:
                return CreditRatingCalculatorEventAction.AGE;
            case CreditRatingGtmActionsType.APPLICANTS:
                return CreditRatingCalculatorEventAction.APPLICANTS;
            case CreditRatingGtmActionsType.PROPERTY_TYPE:
                return CreditRatingCalculatorEventAction.PROPERTY_TYPE;
            case CreditRatingGtmActionsType.CALL:
                return CreditRatingCalculatorEventAction.CALL;
            case RangeOptionNameType.AVERAGE_EARNINGS:
                return CreditRatingCalculatorEventAction.LOAN_INSTALLMENTS;
            case RangeOptionNameType.LOAN_INSTALLMENTS:
                return CreditRatingCalculatorEventAction.AVERAGE_EARNINGS;
            case RangeOptionNameType.HOUSEHOLD_EXPENSES:
                return CreditRatingCalculatorEventAction.HOUSEHOLD_EXPENSES;
        }
    }

    console.error(`wrong event for one of credit calculators`);
    return null;
};

export const getCreditEventActionFromCalculatorValueType = (type: CalculatorValueType) => {
    switch (type) {
        case CalculatorValueType.PRICE:
            return CreditCalculatorInstalmentEventAction.PRICE;
        case CalculatorValueType.PERIOD:
            return CreditCalculatorInstalmentEventAction.PERIOD;
        case CalculatorValueType.CONTRIBUTION:
            return CreditCalculatorInstalmentEventAction.CONTRIBUTION;
        default:
            console.error(`getCreditEventActionFromCalculatorValueType wrong type`);
            return "";
    }
};
